<div class="container card">

  <h1 class=""></h1>

  <div class="row">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
        <input matEndDate placeholder="End date" [(ngModel)]="endDate">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <!-- Centre Selection with Read More -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Select Centre</mat-label>

      <mat-select [(ngModel)]="selectedCentreCode" multiple>

        <!-- READ MORE TRIGGER -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedCentreCode?.length; else placeholderCentre">
            {{ getCentreNameByCode(selectedCentreCode[0]) }}
            <span *ngIf="selectedCentreCode.length > 1"
                  class="read-more-text"
                  matTooltip="{{ getSelectedCentreNamesDisplay() }}">
              + {{ selectedCentreCode.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderCentre>
            Select Centre
          </ng-template>
        </mat-select-trigger>

        <!-- OPTIONS -->
        <mat-option *ngFor="let c of (_centres$ | async)"
                    [value]="c.centreCode">
          {{ c.centreName }}
        </mat-option>

      </mat-select>
    </mat-form-field>

    <!-- Gender Filter (Single Select - No Change) -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Gender</mat-label>
      <mat-select [(ngModel)]="selectedGender" (selectionChange)="getGender($event)">
        <mat-option value="All">All</mat-option>
        <mat-option value="Female">Female</mat-option>
        <mat-option value="Male">Male</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Challenges Faced with Read More -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Challenges Faced</mat-label>
      <mat-select [(ngModel)]="selectedChallenges" (selectionChange)="getSelectedChallenges($event)" multiple>

        <!-- READ MORE TRIGGER -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedChallenges?.length; else placeholderChallenges">
            {{ selectedChallenges[0] }}
            <span *ngIf="selectedChallenges.length > 1"
                  class="read-more-text"
                  matTooltip="{{ getSelectedChallengesDisplay() }}">
              + {{ selectedChallenges.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderChallenges>
            Select Challenges
          </ng-template>
        </mat-select-trigger>

        <mat-option *ngFor="let challenges of (mChallengesFaced)" [value]="challenges">
          {{ challenges }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Interventions with Read More -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Interventions</mat-label>
      <mat-select [(ngModel)]="selectedIntervention" (selectionChange)="getSelectedInterventions($event)" multiple>

        <!-- READ MORE TRIGGER -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedIntervention?.length; else placeholderInterventions">
            {{ selectedIntervention[0] }}
            <span *ngIf="selectedIntervention.length > 1"
                  class="read-more-text"
                  matTooltip="{{ getSelectedInterventionsDisplay() }}">
              + {{ selectedIntervention.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderInterventions>
            Select Interventions
          </ng-template>
        </mat-select-trigger>

        <mat-option *ngFor="let i of (interventions | async)" [value]="i">
          {{ i }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Counsellor Name with Read More -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Counsellor Name</mat-label>
      <mat-select [(ngModel)]="selectedCounselorName" (selectionChange)="getCounselorName($event)" multiple>

        <!-- READ MORE TRIGGER -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedCounselorName?.length; else placeholderCounselor">
            {{ selectedCounselorName[0] }}
            <span *ngIf="selectedCounselorName.length > 1"
                  class="read-more-text"
                  matTooltip="{{ getSelectedCounselorNamesDisplay() }}">
              + {{ selectedCounselorName.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderCounselor>
            Select Counsellor
          </ng-template>
        </mat-select-trigger>

        <mat-option *ngFor="let name of counselorName" [value]="name">
          {{ name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Action Buttons -->
    <div class="d-flex justify-content-end gap-2">
      <button class="ms-5" mat-mini-fab color="accent" (click)="searchData()">
        <mat-icon>search</mat-icon>
      </button>
      <button class="mx-2" mat-mini-fab color="accent" (click)="Clear()">
        <mat-icon>clear</mat-icon>
      </button>
      <button class="mx-2" mat-mini-fab color="primary" (click)="downloadExcel()">
        <mat-icon>download</mat-icon>
      </button>
    </div>

  </div>

  <div #content>
    <div class="d-flex justify-content-between  ">
      <div></div>

      <img src="assets/logo.png" alt="logo">

    </div>

    <div class="text-center text-dark mb-4">
      <h1>Intervention Report</h1>
    </div>
    <div class="text-center">
      <h3 *ngIf="selectedGender"> Gender Selected: {{ selectedGender }}</h3>
      <h3 *ngIf="startDate &&endDate">From: {{ startDate|date:'dd-MMM-yyyy' }} to {{ endDate|date:'dd-MMM-yyyy' }} </h3>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="card">

          <div class="header">
            <h2 class="text-center">Interventions Chart</h2>
          </div>
          <div class="body" *ngIf="mShowInterventionsChart">
            <apx-chart [series]="interventionsChartOptions.series!" [chart]="interventionsChartOptions.chart!"
                       [xaxis]="interventionsChartOptions.xaxis!" [yaxis]="interventionsChartOptions.yaxis!"
                       [colors]="interventionsChartOptions.colors!"
                       [plotOptions]="interventionsChartOptions.plotOptions!"
                       [stroke]="interventionsChartOptions.stroke!" [legend]="interventionsChartOptions.legend!"
                       [grid]="interventionsChartOptions.grid!"
                       [tooltip]="interventionsChartOptions.tooltip!"
                       [dataLabels]="interventionsChartOptions.dataLabels!"></apx-chart>

          </div>
        </div>
      </div>
      <div class="col-md-12" style="page-break-before: always">
        <div class="card">
          <div class="header">
            <h2 class="text-center">Challenges Chart</h2>
          </div>
          <div class="body" *ngIf="mShowChart">
            <apx-chart [series]="areaChartOptions.series!" [chart]="areaChartOptions.chart!"
                       [xaxis]="areaChartOptions.xaxis!" [yaxis]="areaChartOptions.yaxis!"
                       [colors]="areaChartOptions.colors!"
                       [stroke]="areaChartOptions.stroke!" [legend]="areaChartOptions.legend!"
                       [grid]="areaChartOptions.grid!"
                       [tooltip]="areaChartOptions.tooltip!" [dataLabels]="areaChartOptions.dataLabels!"></apx-chart>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="card">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>
    </mat-form-field>
    <div [ngStyle]="tableStyles">
      <table mat-table [dataSource]="dataSource" style="width: 100%" matSort class="body">
        <!-- Define columns -->
        <ng-container matColumnDef="sr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Sr</th>
          <td mat-cell *matCellDef="let element;let i =index"> {{ i + 1 }}</td>
        </ng-container>
        <ng-container matColumnDef="childName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name</th>
          <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.childName"
              matTooltipPosition="above"> {{ element.childName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="sessionDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Date</th>
          <td mat-cell *matCellDef="let element"> {{ (element.date)?.toDate() |date:'dd/MM/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="sessionType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Session Type</th>
          <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.type"
              matTooltipPosition="above"> {{ element.type }}
          </td>
        </ng-container>
        <ng-container matColumnDef="intervention">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Intervention</th>
          <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.interventions"
              matTooltipPosition="above"> {{ element.interventions }}
          </td>
        </ng-container>
        <ng-container matColumnDef="challenges">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Challenges</th>
          <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.challengesFaced"
              matTooltipPosition="above"> {{ element.challengesFaced }}
          </td>
        </ng-container>
        <ng-container matColumnDef="submittedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Counsellor Name</th>
          <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.submittedBy"
              matTooltipPosition="above"> {{ element.submittedBy }}
          </td>
        </ng-container>
        <!-- Repeat for other columns -->

        <!-- Render rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 500]" showFirstLastButtons></mat-paginator>

  </div>

</div>
